import React from "react"
import Icon from "../../icon/icon.component"
import FeatureProtectionWrapperMain from "./featureProtectionWrapperMain.component"
import { injectIntl } from "react-intl"
import Toggle from "react-toggle"
import { messages } from "./helpers"
import ReactTooltip from "react-tooltip"
import { FeatureProtectedToggleProps } from "./type"

export const FeatureProtectedToggle = injectIntl((props: FeatureProtectedToggleProps) => {
    const lockedItem = (
        <span>
            <ReactTooltip
                place="right"
                type="warning"
                effect="solid"
                multiline={true}
                id="featureProtectedToggle"
            />
            <a href={`/my-account?utm_source=${props.featureKey}`}
                data-tip={props.intl.formatMessage(messages["update_subscription"])}
                data-for="featureProtectedToggle">
                <Icon value="lock" className="lock"/>
            </a>
        </span>
    )

    const item = (
        <Toggle
            checked={props.checked}
            icons={false}
            onChange={e => props.onChange && props.onChange(e)}
        />
    )

    return (
        <>
            <FeatureProtectionWrapperMain
                accountFeatureKey={props.featureKey}
                displayModal={false}
                isProtected={true}
                lockedItem={lockedItem}
                item={item}
            />
        </>
    )


})



// WEBPACK FOOTER //
// ./src/common/rich-text/feature-protection-wrappers/FeatureProtectedToggle.tsx